import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { SIDEBAR_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../base/base.component";
import { SidebarItemModel } from "../../../crossconcern/models/sidebarItem.model";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { SidebarUtils } from "../../../crossconcern/utilities/utils/sidebar.utils";
import { Location } from "@angular/common";
import {
    DIM_BREAKPOINT_DESKTOP_WIDTH,
    LANG_CODE_EN, LANG_CODE_FR,
    LANG_CODE_IT
} from "../../../crossconcern/utilities/properties/base.property";
import { logData } from "../../../crossconcern/helpers/generic/generic.helper";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { TranslateService } from "@ngx-translate/core";
import { UserManager } from "../../../business/managers/user.manager";

@Component({
    selector: SIDEBAR_SELECTOR,
    templateUrl: "./sidebar.component.html"
})
export class SidebarComponent extends BaseComponent implements OnInit {

    public sidebarItems: SidebarItemModel[] = [];

    public lastExpandedItem: SidebarItemModel;
    public lastActiveChild: SidebarItemModel;

    @Output()
    public onItemClick: EventEmitter<SidebarItemModel> = new EventEmitter();

    @Output() public onSidebarLoaded: EventEmitter<string> = new EventEmitter();
    @Output() public onSidebarToggle: EventEmitter<string> = new EventEmitter();

    constructor(protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        protected sidebarUtils: SidebarUtils,
        protected translate: TranslateService,
        protected userManager: UserManager,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
    }

    public ngOnInit(): void {
        this.sidebarItems = this.sidebarUtils.getElements();
        logData(this.sidebarItems);
        this.lastExpandedItem = this.sidebarItems.find((item) => !item.isCollapsed);
        // this.lastActiveChild = this.lastExpandedItem.children.find((item) => item.isActive);
        this.onSidebarLoaded.emit();
    }

    public toggleSidebar() {
        this.onSidebarToggle.emit();
    }

    public toggleCollapsed(item: SidebarItemModel) {
        if (this.lastExpandedItem && item !== this.lastExpandedItem) {
            this.lastExpandedItem.isCollapsed = true;
        }
        item.isCollapsed = !item.isCollapsed;
        this.lastExpandedItem = item;
        if (!(item.children && item.children.length > 0)) {
            this.onClick(item);
        }
    }

    public onClick(item: SidebarItemModel) {
        this.onItemClick.emit(item);
        if (this.lastActiveChild) {
            this.lastActiveChild.isActive = false;
        }
        item.isActive = true;
        this.lastActiveChild = item;
        if (window.innerWidth <= DIM_BREAKPOINT_DESKTOP_WIDTH) {
            this.toggleSidebar();
        }
    }

    public onItemHover(item: SidebarItemModel) {
        item.isHover = true;
    }

    public onItemOut(item: SidebarItemModel) {
        item.isHover = false;
    }

    public setLanguage(language: string) {
        this.translate.use(language);
        this.userManager.setCurrentLanguage(language);
    }

    public setLanguageEnglish() {
        this.setLanguage(LANG_CODE_EN);
    }

    public setLanguageItalian() {
        this.setLanguage(LANG_CODE_IT);
    }

    public setLanguageFrench() {
        this.setLanguage(LANG_CODE_FR);
    }

    public currentLangItalian(): boolean {
        const currentLang = this.translate.currentLang;
        if (currentLang === LANG_CODE_IT) {
            return true;
        }
        return false;
    }

    public currentLangEnglish(): boolean {
        const currentLang = this.translate.currentLang;
        if (currentLang === LANG_CODE_EN) {
            return true;
        }
        return false;
    }

    public currentLangFrench(): boolean {
        const currentLang = this.translate.currentLang;
        if (currentLang === LANG_CODE_FR) {
            return true;
        }
        return false;
    }
}
